import React from 'react'
import { withRouter } from "react-router-dom";
// import FormComponent,{FormOp, Validators} from '../../../form/FormOps';
import Http from '../../../../Http';
import { FormComponent } from '../../../../components/form/DynamicForm';
import { Form, Validators } from '../../../../components/form/DynamicFormTs';
import ClienteDatosContactos from './DatosContactos'

class ClienteDatosGenerales extends FormComponent {

  componentDidMount() {

    this.FormConfig(
      { defaultUrl: 'cliente/one', saveUrl: 'cliente/save', backUrl: '/Catalogos/Clientes' },
      new Form([
        Form.Field('number', 'cliente_cp', 'Código Postal', '', [Validators.required], 2),
        Form.Field('autocomplete', 'cliente_id_colonia', 'Colonia', '', [Validators.required], 5),
        Form.Field('text', 'cliente_domicilio', 'Domicilio', '', [Validators.required], 5),
        Form.Field('text', 'cliente_next', 'N. Ext', '', [], 3),
        Form.Field('text', 'cliente_nint', 'N. Int', '', [], 3),
        Form.Field('text', 'cliente_telefono', 'Teléfono', '', [Validators.required], 6),
        Form.Field('select', 'cliente_id_estado', 'Estado', '', [Validators.required], 6),
        Form.Field('select', 'cliente_id_ciudad', 'Delegación o municipio', '', [Validators.required], 6),
        Form.Field('select', 'cliente_id_grupo_embalaje', 'Grupo de Embalaje', '1', [Validators.required], 6),
        Form.Field('select', 'cliente_id_tipo_precio', 'Tipo Precio', '1', [Validators.required], 6, [
          { Label: 'Consolidado', Value: '1' },
          { Label: 'Porcentaje', Value: '2' },
          { Label: 'Devolución', Value: '3' },
        ]),
        Form.Field('checkbox', 'cliente_nuevo', 'Cliente Nuevo', '', [], 6),
        Form.Field('date', 'cliente_fecha_alta', 'Fecha de alta', '', [], 6)
      ],
        ['Guardar'], ''), this.formData)
    // console.log(this.props.match)
    if (this.props.match.params.id)
      this.LoadPreds(this.props.match.params.id)
  }

  formData = async (form) => {
    var Res = await Http.get(`cliente/form-generales?${(this.formEstado) ? `e=${this.formEstado}&` : ''}${(this.formCp) ? `cp=${this.formCp}` : ''}`);

    if (!Res.error) {
      var newForm = Form.FieldOptions(form, 'cliente_id_estado', Res.data.estados, 'id', 'estado');
      if (Res.data.ciudades) newForm = Form.FieldOptions(newForm, 'cliente_id_ciudad', Res.data.ciudades, 'id', 'ciudad');
      if (Res.data.grupo_embalajes) newForm = Form.FieldOptions(newForm, 'cliente_id_grupo_embalaje', Res.data.grupo_embalajes, 'id', 'grupo');
      if (Res.data.direccion) {
        const { direccion } = Res.data;
        newForm = Form.FieldOptions(newForm, 'cliente_id_colonia', direccion.colonias, 'id', 'colonia');
        newForm = Form.FieldOptions(newForm, 'cliente_id_ciudad', direccion.ciudades, 'id', 'ciudad');
        newForm = Form.Patch(newForm, { cliente_id_estado: direccion.estado.id, cliente_id_ciudad: direccion.ciudad.id }, false);
        newForm = Form.FieldMod(newForm, 'cliente_id_estado', 'Disabled', true);
        newForm = Form.FieldMod(newForm, 'cliente_id_ciudad', 'Disabled', true);
      }
      newForm = Form.ValueChange(newForm, {
        cliente_id_estado: this.estadoChange,
        cliente_cp: this.cliCpChange,
      });
      return newForm;
    }
  }

  cliCpChange = async (field) => {
    let formData = this.state.FormData;
    if (field.Value.length === 5) {
      this.formCp = field.Value;
      this.setState({ FormData: await this.formData(formData) });
    } else {
      formData = Form.Patch(formData, { cliente_id_colonia: '' })
      formData = Form.FieldOptions(formData, 'cliente_id_colonia', [], 'id', 'colonia');
      this.setState({ FormData: formData }); 
    }
  }

  estadoChange = async (field) => {
    this.formEstado = field.Value;
    this.setState({ FormData: await this.formData(this.state.FormData) })
  }

  onSubmit = async (i, vals) => {
    vals.id = this.props.match.params.id;
    var Res = await Http.post(`${this.config.saveUrl}`, vals);
    if (!Res.error) {
      this.setState({ loading: false, sbMsg: 'Guardado', sbOpen: true });
      this.props.onSave();
    }
    else
      this.setState({ loading: false, sbMsg: 'Error al guardar', sbOpen: true });

  }

  render() {
    return (
      <div>
        <this.FormRender />
        <ClienteDatosContactos />
      </div>
    )
  }
}

export default withRouter(ClienteDatosGenerales)
